import RMSelect from 'components/customComponents/Controls/RMSelect';
import React, { useState, useEffect, useContext } from 'react';
import './ScreenExperimentWizard.scss';
import WizardContentParent from './WizardContentParent';
import RMImagingSchedule from 'components/customComponents/Controls/RMImagingSchedule';
import RMMultipleCheckboxes from 'components/customComponents/Controls/RMMultipleCheckboxes';
import ScreenWizardContext from './ScreenWizardContext';
import { TreeService } from 'business/services/TreeService';
import {
  ExperimentInfoImagingScheduleDTO,
  OwnerInfo,
  UsersDTO,
} from 'business/models/Models';
import { isNullOrUndefined } from 'utils/Global';
import { SelectType } from 'business/models/CustomModels';
import { IStyle } from 'Styles';

const styles: IStyle = {
  checkboxContainer: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
  },
};

function DefineParametersWizard() {
  const screenExpWiz = useContext(ScreenWizardContext);
  const [selectedOwner, setSelectedOwner] = useState(screenExpWiz.owner?.id);
  const [imagingSchedules, setImagingSchedules] =
    useState<ExperimentInfoImagingScheduleDTO>(null);
  const [selImagingSchedule, setSelImagingSchedule] = useState(
    screenExpWiz.imagingSchedule?.id,
  );
  const [users, setUsers] = useState<UsersDTO[]>([]);
  function onChangeOwner(event) {
    const numberVal = parseInt(event.target.value);
    setSelectedOwner(numberVal);
    const selUser = users.find((user) => user.id == numberVal);
    screenExpWiz.setWizardDataDirty(true);
    const user = new OwnerInfo();
    user.id = selUser.id;
    user.name = selUser.name;
    screenExpWiz.setOwner(selUser);
  }

  function setDefaultTemp(temps) {
    if (screenExpWiz.incubationTemp.length == 0) {
      screenExpWiz.setIncubationTemp([
        temps[0].id,
        //temps.find((temp) => temp.name == 20).id
      ]);
    }
  }

  function onCheckboxChange(tempId) {
    if (screenExpWiz.incubationTemp.includes(tempId)) {
      screenExpWiz.setIncubationTemp([
        ...screenExpWiz.incubationTemp.filter((temp) => temp != tempId),
      ]);
    } else {
      screenExpWiz.setIncubationTemp([...screenExpWiz.incubationTemp, tempId]);
    }
    screenExpWiz.setWizardDataDirty(true);
  }

  useEffect(() => {
    async function fetchData() {
      const treeService: TreeService = new TreeService();
      const usersTempSchedules = await treeService.getUsersTempsImagingSchedules();
      setImagingSchedules(usersTempSchedules.imagingSchedules);
      setUsers(usersTempSchedules.users);
      if (!isNullOrUndefined(usersTempSchedules.imagingSchedules)) {
        if (isNullOrUndefined(screenExpWiz.imagingSchedule)) {
          screenExpWiz.setImagingSchedule(
            usersTempSchedules.imagingSchedules.imagingSchedules[0],
          );
        }
      }
      const tempsLocal = usersTempSchedules.temps;
      screenExpWiz.setAllTemps(usersTempSchedules.temps);
      if (isNullOrUndefined(screenExpWiz.owner)) {
        screenExpWiz.setOwner(usersTempSchedules.users[0]);
      }
      setDefaultTemp(tempsLocal);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (isNullOrUndefined(imagingSchedules)) {
      return;
    }
    const imgSchedule = imagingSchedules.imagingSchedules.find(
      (imgSchedule) => imgSchedule.id === selImagingSchedule,
    );
    if (imgSchedule.id != screenExpWiz.imagingSchedule?.id) {
      screenExpWiz.setWizardDataDirty(true);
    }
    screenExpWiz.setImagingSchedule(imgSchedule);
  }, [selImagingSchedule]);

  return (
    <div
      id="defineparameterswizard-wrapper"
      className="define-parameter-container"
      style={{ maxHeight: '100%', maxWidth: '100%', height: '100%' }}
    >
      <div
        id="defineparameterswizard-content-wrapper"
        className="flex flex-column"
        style={{ width: '30%', height: '100%' }}
      >
        <WizardContentParent
          id="defineparameterswizard-selectowner"
          heading="Select Owner"
          className="select-owner"
          style={{ height: '25%' }}
        >
          <RMSelect
            options={users as SelectType[]}
            placeholder={null}
            onChange={onChangeOwner}
            selectedValue={selectedOwner}
          />
        </WizardContentParent>
        <WizardContentParent
          id="defineparameterswizard-selecttemperature"
          className="select-temprature"
          heading="Selected Incubation Temperature (°C)"
          childStyle={{ height: '70%' }}
          style={{ height: '61%' }}
        >
          <RMMultipleCheckboxes
            checkboxs={screenExpWiz.allTemps}
            selectedValues={screenExpWiz.incubationTemp}
            onCheckboxChange={onCheckboxChange}
            checkboxContainerStyle={styles.checkboxContainer}
            labelClass={'ml-6'}
          />
        </WizardContentParent>
      </div>
      <WizardContentParent
        id="defineparameterswizard-imagingschedule"
        className="schedule screen-wizard-table wizard-scheduling-table"
        style={{ width: '70%', height: '90%', maxWidth: '72%' }}
        heading="Schedule"
      >
        <RMImagingSchedule
          imgSchedules={imagingSchedules}
          selImagingSchedule={selImagingSchedule}
          setSelImagingSchedule={setSelImagingSchedule}
        />
      </WizardContentParent>
    </div>
  );
}

export default DefineParametersWizard;
